module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchContent"
  }, [_c('div', {
    staticClass: "page-item route"
  }, [(_vm.key != '' && _vm.key != null && _vm.key != undefined) ? _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("全部结果")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.key))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "searchtree"
  }, [(_vm.categorylist.length > 0 && !_vm.supplierId) ? _c('div', {
    staticClass: "searchtree-item"
  }, [_c('div', {
    staticClass: "searchtree-label"
  }, [_vm._v("分类:")]), _vm._v(" "), _c('ul', _vm._l((_vm.categorylist), function(cate, j) {
    return _c('li', {
      key: j,
      class: _vm.categoryId == cate.value ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.clickCate(cate.value)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(cate.name) + "\n                          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandlist.length > 0 && !_vm.supplierId) ? _c('div', {
    staticClass: "searchtree-item"
  }, [_c('div', {
    staticClass: "searchtree-label"
  }, [_vm._v("品牌:")]), _vm._v(" "), (!_vm.isShowMoreBrand) ? _c('ul', {
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.showBrandlist), function(brand, i) {
    return _c('li', {
      key: i,
      class: _vm.brandId == brand.value ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.clickBrand(brand.value)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(brand.name) + "\n                          ")])
  }), _vm._v(" "), (_vm.brandlist.length > 24) ? _c('li', {
    staticClass: "brandBtn",
    on: {
      "click": function($event) {
        return _vm.setBrandShow(true)
      }
    }
  }, [_vm._v("展开"), _c('i', {
    staticClass: "icon icon-list"
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isShowMoreBrand) ? _c('ul', {
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.brandlist), function(brand, i) {
    return _c('li', {
      key: i,
      class: _vm.brandId == brand.value ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.clickBrand(brand.value)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(brand.name) + "\n                          ")])
  }), _vm._v(" "), (_vm.brandlist.length > 24) ? _c('li', {
    staticClass: "brandBtn",
    on: {
      "click": function($event) {
        return _vm.setBrandShow(false)
      }
    }
  }, [_vm._v("收缩"), _c('i', {
    staticClass: "icon icon-list1"
  })]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.supplierId > 0) ? _c('div', {
    staticClass: "searchtree-item supplierInfo"
  }, [_c('div', {
    staticClass: "searchtree-label"
  }, [_vm._v("店铺:")]), _vm._v(" "), _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": _vm.supplierLogo
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shopName"
  }, [_vm._v(_vm._s(_vm.supplierName))]), _vm._v(" "), _c('div', {
    staticClass: "supplierCollect"
  }, [(_vm.isLogined && !_vm.isCollectSupplier) ? _c('input', {
    staticClass: "collectBtn",
    attrs: {
      "type": "button",
      "value": "收藏店铺"
    },
    on: {
      "click": function($event) {
        return _vm.handleCollect()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLogined && _vm.isCollectSupplier) ? _c('input', {
    staticClass: "collectBtn1",
    attrs: {
      "type": "button",
      "value": "移除收藏"
    },
    on: {
      "click": function($event) {
        return _vm.handleRemoveCollect()
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searchtree-item"
  }, [_c('div', {
    staticClass: "searchtree-label"
  }, [_vm._v("排序:")]), _vm._v(" "), _c('ul', [_c('li', {
    class: _vm.sortType == 1 ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.sortFun(1)
      }
    }
  }, [_vm._v("\n                            综合                              \n                          ")]), _vm._v(" "), _c('li', {
    class: (_vm.sortType == 2 || _vm.sortType == 3) ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.sortFun(_vm.sortType == 2 ? 3 : 2)
      }
    }
  }, [_vm._v("\n                            价格       \n                            "), _c('i', {
    class: 'icon ' + (_vm.sortType == 2 ? 'icon-sort0' : 'icon-sort1')
  })]), _vm._v(" "), _c('li', {
    class: _vm.sortType == 4 ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.sortFun(4)
      }
    }
  }, [_vm._v("\n                            销量                              \n                          ")]), _vm._v(" "), _c('li', {
    class: _vm.sortType == 5 ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.sortFun(5)
      }
    }
  }, [_vm._v("\n                            新品                              \n                          ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabcontent",
    attrs: {
      "element-loading-text": "数据加载中,请稍后..."
    }
  }, [_c('ul', _vm._l((_vm.goods), function(item, i) {
    return _c('li', {
      key: i
    }, [_c('div', {
      staticClass: "productIamge"
    }, [_c('img', {
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }), _vm._v(" "), _vm._l((item.labels), function(labelItem, labelIndex) {
      return (labelIndex < 1 && labelItem.labelIcon) ? _c('img', {
        key: labelIndex,
        staticClass: "productIcon",
        attrs: {
          "src": labelItem.labelIcon
        }
      }) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "productname"
    }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('div', {
      staticClass: "productprice"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                    ￥" + _vm._s(item.settlementPrice) + "\n                                    "), (item.settlementPrice < item.sellPrice) ? _c('span', {
      staticClass: "scribe"
    }, [_vm._v("\n                                      ￥" + _vm._s(item.sellPrice) + "\n                                  ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "sales"
    }, [_vm._v("\n                                      成交" + _vm._s(item.sales) + "件\n                                   ")])]), _vm._v(" "), _c('div', {
      staticClass: "operationBtn"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_c('y-button', {
      attrs: {
        "text": "查看详情"
      }
    })], 1), _vm._v(" "), _c('y-button', {
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      },
      on: {
        "btnClick": function($event) {
          return _vm.showModal(item)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), (!_vm.noResult && !_vm.error) ? _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage3,
      "layout": "prev, pager, next, jumper",
      "total": _vm.goodsTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.currentPage3 = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage3 = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('selectSpec', {
    ref: "selectSpec"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "icon icon-more"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27a653d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/index.vue
// module id = 748
// module chunks = 2